/**
 * Benutzer anlegen in der Kunden-Instanz (cockpit-api POST /users, TQ #409).
 */

export interface CreateTenantUserResponse {
  success: boolean
  keycloak_id?: string
  member?: { invitation_sent?: boolean }
}

/** Nur ein ausdrueckliches `member.invitation_sent === true` gilt als verschickt. */
export function isInvitationSent(res: CreateTenantUserResponse): boolean {
  return res.member?.invitation_sent === true
}

const TENANT_STATUS_TEXT: Record<number, string> = {
  403: 'Keine Berechtigung für diese Rolle.',
  404: 'Benutzer wurde nicht gefunden.',
  409: 'Dieser Benutzer ist bereits Mitglied.',
  502: 'Die Einladung konnte nicht verschickt werden (Mail/Keycloak). Bitte später erneut versuchen.',
}

/** Deutsche Status-Texte haben Vorrang vor dem (oft englischen) `data.error` des Servers. */
export function createUserErrorMessage(
  status: number | undefined,
  serverError: string | undefined,
  tenant: boolean,
): string {
  if (tenant && status !== undefined && TENANT_STATUS_TEXT[status]) return TENANT_STATUS_TEXT[status]
  return serverError || 'Benutzer konnte nicht erstellt werden'
}
